import {
    GET_CASHPASS_EXCLUSIONS,
    RESET_CASHPASS_EXCLUSIONS,
} from '../actionTypes/CashpassExclusionsActionTypes';


export const getCashpassExclusions = () => ({
    type: GET_CASHPASS_EXCLUSIONS,
});


export const resetCashpassExclusions = () => ({
    type: RESET_CASHPASS_EXCLUSIONS,
});
